import React from 'react';

class ItemPayment extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    return (
      <div className="item-payment-D">
        <h2 className='item-payment-D-name'>{this.props.title}</h2>
        <div className='item-payment-D-content' dangerouslySetInnerHTML={{__html: this.props.content}}></div>
      </div>
    );
  }
}

export default ItemPayment;



// WEBPACK FOOTER //
// ./components/business/business-page/ItemPayment.jsx